import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import signup from "../assets/images/signup.webp";
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import arrow from "../assets/images/arrow-left.png";
import resetPassword from "../assets/images/resetPassword.png";
import { resetPasswordApi } from '../services/AuthApi';
import { showToast } from '../config/Alert';
import LoadingSpinner from './LoadingSpinner';

const ResetPassword = () => {
    const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    const email = queryParams.get("email");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.password || !formData.confirmPassword) {
            showToast("All fields are required", "error");
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            showToast("Passwords do not match", "error");
            return;
        }

        setLoading(true);
        try {
            await resetPasswordApi({
                email: email,
                password: formData.password,
                password_confirmation: formData.confirmPassword,
                token: token
            });
            showToast("Password has been reset successfully!", "success");
            //navigate('/login');
            setTimeout(() => navigate('/login'), 1500);
        } catch (error) {
            const errorMsg = error?.message || "Failed to reset password";
            showToast(errorMsg, "error");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <LoadingSpinner />;
    }

    return (
        <div className='login-form bg_light_yellow p-3'>
            <div className='login_main_form bg-white rounded-4'>
                <div className='text-center'>
                    <img src={resetPassword} alt="signup" className='img-fluid mb-3' />
                    <h1 className='fw-bold text-danger fs-20'>Reset Password</h1>
                    <h6 className='text-muted fs-10'>Enter new password below to change your password.</h6>
                </div>
                <Form className='mb-5 pt-3' onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="password">
                        <Form.Control
                            type="password"
                            size='lg'
                            className='border-2 border-secondary fs-14'
                            placeholder='New Password'
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="confirmPassword">
                        <Form.Control
                            type="password"
                            size='lg'
                            className='border-2 border-secondary fs-14'
                            placeholder='Confirm Password'
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group className='text-center'>
                        <Button variant="info" size='lg' type="submit" className='px-5 text-white border-2 border-secondary'>
                            Reset Password
                        </Button>
                    </Form.Group>
                    <p className='text-center mt-2'><Link to='/login' className='fw-bold text-decoration-none fs-12 text-muted'><img src={arrow} width={10} alt="link" /> Back to login</Link></p>
                </Form>

                <img src={signup} alt="signup" className='img-fluid' />
            </div>
        </div>
    );
}

export default ResetPassword;